import { Action, createReducer, on } from '@ngrx/store';

import { selectHourTypeAction } from '@shared/base-search-bar/store//actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';

export const initialState = ['3'];

const reducer = createReducer(
  initialState,
  on(selectHourTypeAction, (state, { hourType }) => {
    return hourType;
  }),
  on(loadSearchDataSuccessAction, (state, { data }) => data ? data.hourType : initialState)
);

export function hourTypeReducer(state: string[], action: Action): string[] {
  return reducer(state, action);
}
